export const FORM_NAMS = {
    W_2: "W-2",
    $1099_MISC: "1099-MISC",
    $1099_NEC: "1099-NEC",
    $1099_B: "1099-B",
    $1099_R: "1099-R",
    $1099_K: "1099-K",
    $1095_B: "1095-B",
    $1095_C: "1095-C",
    Form941: "Form941",
    Form941PR: "Form941PR",
}

export const FORM_NAMS_WITHOUT_HYPHEN = {
    W_2: "W2",
    $1099_MISC: "1099MISC",
    $1099_NEC: "1099NEC",
    $1099_B: "1099B",
    $1099_R: "1099R",
    $1099_K: "1099K",
    $1095_B: "1095B",
    $1095_C: "1095C",
}